module.exports = __webpack_public_path__ + "static/media/candidate-unsorted.3cec164c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/candidate-unsorted.svg
// module id = 1194
// module chunks = 1